module.exports = __webpack_public_path__ + "img/NORD-PRO-TC.099439ec.png";